import { NsThemeName } from "./ns-eds-types";

export function setTractieColorScheme(colorScheme: NsThemeName): void {
  // Tractie components use the `data-color-scheme` attribute to determine the theme.
  document.documentElement.dataset.colorScheme = colorScheme;
}
